import { CTA } from "@/ui";
import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import { getYoutubeIdFromUrl } from "@/functions/getYoutubeIdFromUrl";
import { getYoutubeVideoEmbedUrl } from "@/functions/getYoutubeVideoEmbedUrl";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import {
  LinkedinShareButton,
  LinkedinIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import ShareIcon from "@/assets/share.svg";

export const IntroSection = ({
  className,
  body,
  embed_media,
  showShareButton,
  bgColor,
  textColor,
  shareTextColor,
  showCta,
  cta,
  maxWidth,
}) => {
  const youtubeId = embed_media ? getYoutubeIdFromUrl(embed_media) : null;
  const embedUrl = youtubeId ? getYoutubeVideoEmbedUrl(embed_media) : null;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="d-flex h-100 w-100 align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className={clsx(className, classes.content, "py-5", `bg-${bgColor}`, `text-${textColor}`)}>
      <Container className={maxWidth}>
        <Row className={clsx(classes.intro)}>
          <Col xs={12} md={8}>
            <div className={classes.content} dangerouslySetInnerHTML={{ __html: body }} data-sourceflow-prop="body" />
            {showCta && <CTA className="mt-4" label={cta.label} href={cta.href} variant={cta.variant} />}
            {embedUrl && (
              <div className="ratio ratio-16x9 mt-4">
                <iframe
                  src={embedUrl}
                  title="Embedded YouTube Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            )}
          </Col>
          {showShareButton && (
            <Col xs={12} md={4}>
              <Dropdown className={classes.share}>
                <Dropdown.Toggle variant="outline-dark">
                  <ShareIcon width={25} height={25} />
                  <span className={clsx("ms-3 me-2")}>Share</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item>
                    <LinkedinShareButton url={window.location.href}>
                      <LinkedinIcon size={25} round={true} /> LinkedIn
                    </LinkedinShareButton>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <FacebookShareButton url={window.location.href}>
                      <FacebookIcon size={25} round={true} /> Facebook
                    </FacebookShareButton>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <TwitterShareButton url={window.location.href}>
                      <TwitterIcon size={25} round={true} /> X
                    </TwitterShareButton>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <WhatsappShareButton url={window.location.href}>
                      <WhatsappIcon size={25} round={true} /> WhatsApp
                    </WhatsappShareButton>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <EmailShareButton url={window.location.href}>
                      <EmailIcon size={25} round={true} /> Email
                    </EmailShareButton>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default IntroSection;
